import React from 'react';

export function Modal({ isOpen, onClose, title, children, maxWidth = 'max-w-2xl' }) {
    if (!isOpen) return null;

    // Función para cerrar el modal al hacer clic en el fondo (backdrop)
    const handleBackdropClick = (e) => {
        // Cierra solo si el clic es directamente en el fondo
        if (e.target === e.currentTarget) {
            onClose();
        }
    };

    return (
        <div 
            className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 dark:bg-black/70"
            onClick={handleBackdropClick} // Clic en el fondo para cerrar
        >
            <div 
                className={`bg-white dark:bg-gray-900 p-6 rounded-lg shadow-xl relative ${maxWidth} w-full mx-4 my-8 max-h-[90vh] overflow-y-auto border border-gray-200 dark:border-gray-600 dark:text-gray-100`}
                onClick={(e) => e.stopPropagation()} // Evita que el clic en el contenido cierre el modal
            >
                {/* Botón para cerrar el modal */}
                <button 
                    onClick={onClose} 
                    className="absolute top-4 right-4 text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200 transition-colors"
                    aria-label="Cerrar modal"
                >
                    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </button>
                
                {/* Título del modal si se proporciona */}
                {title && (
                    <h2 className="text-xl font-bold mb-4 text-gray-800 dark:text-gray-100">{title}</h2>
                )}
                
                {/* Contenido del modal */}
                <div className="p-4 bg-inherit rounded-md">
                    {children}
                </div>
            </div>
        </div>
    );
}

// Para la animación en Tailwind, necesitarás agregar esto a tu tailwind.config.js
// keyframes: {
//   'modal-fade-in': {
//     '0%': { opacity: '0', transform: 'scale(0.95)' },
//     '100%': { opacity: '1', transform: 'scale(1)' },
//   }
// },
// animation: {
//   'modal-fade-in': 'modal-fade-in 0.2s ease-out forwards',
// }
